import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard{

  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

      // Lógica de verificación de autenticación y permisos
      //  const isAuthenticated =  // Verificar si el usuario está autenticado
      //  const hasPermissions = // Verificar si el usuario tiene los permisos necesarios

      const token = this.authService.getAuthToken();

      if (token){
        return true;
      }else {
        this.router.navigate(['/login']); // Redirige al inicio de sesión si no cumple los requisitos
        return false
      }



    //  if (isAuthenticated && hasPermissions) {
    //    return true; // Permite el acceso al dashboard
    //  } else {
    //    this.router.navigate(['/login']); // Redirige al inicio de sesión si no cumple los requisitos
    //    return false;
    //  }
    // return true;
  }
}
